import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Dashboard from "./Dashboard";
import Contacts from "./Contacts";
import Businesses from "./Businesses";
import Categories from "./Categories";
import Cities from "./Cities";
import Settings from "./Settings";
import { adminLogout } from "../../services/adminService";

import "../../styles/admin.css";

function AdminLayout() {
  const [tab, setTab] = useState("dashboard");
  const [menuOpen, setMenuOpen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Admin Panel - BusinessNearMe";
  }, []);

  // ✅ Protect admin route
  useEffect(() => {
    const token = localStorage.getItem("adminToken");

    if (!token) {
      navigate("/admin/login");
    }
  }, [navigate]);

  // Change tab and close mobile menu
  const handleTabChange = (tabName) => {
    setTab(tabName);
    setMenuOpen(false);
  };

  // Logout: clear server-side token first, then clear local storage
  const handleLogout = async () => {
    try {
      await adminLogout();
    } catch {
      // server may be unreachable; still clear locally
    }
    localStorage.removeItem("adminToken");
    navigate("/admin/login");
  };

  return (
    <div className="admin-container">

      {/* ADMIN HEADER — mobile only (hidden on desktop via CSS) */}
      <div className="admin-header">
        <span className="admin-header-title">Admin Panel</span>
        {/* Hamburger — only shown on mobile via CSS */}
        <button
          className="admin-hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation menu"
        >
          {menuOpen ? "✕" : "☰"}
        </button>
      </div>

      {/* OVERLAY — tap outside to close menu on mobile */}
      {menuOpen && (
        <div
          className="admin-overlay"
          onClick={() => setMenuOpen(false)}
        />
      )}

      {/* SIDEBAR + CONTENT */}
      <div className="admin-body">

        {/* SIDEBAR */}
        <div className={`admin-sidebar${menuOpen ? " open" : ""}`}>

          {/* NAV — scrolls independently if content overflows */}
          <div className="admin-nav">

            <h2 className="admin-logo">
              Admin Panel
            </h2>

            <button
              onClick={() => handleTabChange("dashboard")}
              className={tab === "dashboard" ? "active" : ""}
            >
              Dashboard
            </button>

            <button
              onClick={() => handleTabChange("contacts")}
              className={tab === "contacts" ? "active" : ""}
            >
              Contacts
            </button>

            <button
              onClick={() => handleTabChange("businesses")}
              className={tab === "businesses" ? "active" : ""}
            >
              Businesses
            </button>

            <button
              onClick={() => handleTabChange("categories")}
              className={tab === "categories" ? "active" : ""}
            >
              Categories
            </button>

            <button
              onClick={() => handleTabChange("cities")}
              className={tab === "cities" ? "active" : ""}
            >
              Cities
            </button>

            <button
              onClick={() => handleTabChange("settings")}
              className={tab === "settings" ? "active" : ""}
            >
              Settings
            </button>

          </div>

          {/* LOGOUT — pinned to sidebar bottom */}
          <button
            className="admin-sidebar-logout"
            onClick={handleLogout}
          >
            Logout
          </button>

        </div>

        {/* CONTENT */}
        <div className="admin-content">

          {tab === "dashboard" && <Dashboard />}

          {tab === "contacts" && <Contacts />}

          {tab === "businesses" && <Businesses />}

          {tab === "categories" && <Categories />}

          {tab === "cities" && <Cities />}

          {tab === "settings" && <Settings />}

        </div>

      </div>
    </div>
  );
}

export default AdminLayout;